exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#_2C1VFfdec87bMdI_uDvYvD{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;background-color:#000}#_3pnZo__fSUgz6Jt8FHD01A{-webkit-animation:_2vqnoLGzNgMIELDpFlncpz 2s infinite linear;animation:_2vqnoLGzNgMIELDpFlncpz 2s infinite linear}@-webkit-keyframes _2vqnoLGzNgMIELDpFlncpz{0%{-webkit-transform:scale(1) rotate(0deg);transform:scale(1) rotate(0deg)}to{-webkit-transform:scale(1) rotate(1turn);transform:scale(1) rotate(1turn)}}@keyframes _2vqnoLGzNgMIELDpFlncpz{0%{-webkit-transform:scale(1) rotate(0deg);transform:scale(1) rotate(0deg)}to{-webkit-transform:scale(1) rotate(1turn);transform:scale(1) rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"root": "_2C1VFfdec87bMdI_uDvYvD",
	"rootSpinner": "_3pnZo__fSUgz6Jt8FHD01A",
	"spin": "_2vqnoLGzNgMIELDpFlncpz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Cover/index.css
// module id = 475
// module chunks = 1